import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import { programBoardDetail } from '@/network/apis/apiUri';
import useAxios from '@/network/useAxios';

import './css/common_program_board_view.scss';

function CommonProgramBoardView(props) {
  const { setSubLocation, title, titleStyle } = props;
  const location = useLocation();
  const history = useHistory();

  const boardId = location.pathname.split('/')[4];
  const boardItemId = location.pathname.split('/')[5];

  const [detailItem] = useAxios(
    programBoardDetail,
    [location.pathname],
    { board_id: boardId, board_item_id: boardItemId, hit: true },
    true
  );
  const { data: detailData, error: detailError } = detailItem;

  useEffect(() => {
    if (detailError) {
      if (detailError?.response?.data?.resultCode?.http_status === 401 && props.mode === 'ko')
        alert('작성자만 확인가능합니다. 로그인 인증 후 확인해주세요.');
      if (detailError?.response?.data?.resultCode?.http_status === 401 && props.mode === 'en')
        alert('Only the author can check. Please verify after logging in.');
      if (detailError?.response?.data?.resultCode?.http_status === 500 && props.mode === 'ko')
        alert('잠시후 다시 시도해 주세요.');
      if (detailError?.response?.data?.resultCode?.http_status === 500 && props.mode === 'en')
        alert('Please try again in a few minutes.');
      history.goBack();
    }
  }, [detailError]);
  useEffect(() => {
    setSubLocation(location.pathname);
  }, []);

  return (
    <div id="CommonProgramBoardView" className="commonProgramBoardView">
      {title &&
        title?.data?.item?.map((v) => {
          if (v.board_id === parseInt(boardId)) {
            return <h2 className="commonProgramBoardView_title">{v.title}</h2>;
          }
          return null;
        })}
      <div className="commonProgramBoardView_content">
        <div className="commonProgramBoardView_content_title-wrap">
          <div className="title-wrap">
            <h4 className="title">{props.mode === 'ko' ? detailData?.title?.[1].text : detailData?.title?.[0].text}</h4>
            {titleStyle === 0 && (
              <div className="info titleStyle_0">
                <span className="info_date">{detailData?.reg_date.substr(0, 11)}</span>
                <span className="info_view">HIT {detailData?.hit_count}</span>
              </div>
            )}
            {titleStyle === 1 && (
              <div className="info titleStyle_1">
                <span className="info_date">{detailData?.reg_date}</span>
              </div>
            )}
          </div>
          <button type="button" className="btnList" onClick={() => history.goBack()}>
            목록
          </button>
        </div>
        <div
          className="commonProgramBoardView_content_info"
          dangerouslySetInnerHTML={{
            __html:
              props.mode === 'ko'
                ? detailData?.content?.[1].text?.replace(/(?:\r\n|\r|\n)/g, '<br />')
                : detailData?.content?.[0].text?.replace(/(?:\r\n|\r|\n)/g, '<br />'),
          }}
        ></div>
      </div>
      <div className="commonProgramBoardView_footer">
        <button type="button" className="btnList" onClick={() => history.goBack()}>
          목록
        </button>
      </div>
    </div>
  );
}

export default CommonProgramBoardView;
